"use client";

import React from "react";

import { GetTenantByDomainResult, GetTenantByIdResult } from "../sanity.types";

const TenantContext = React.createContext<{
	tenant:
		| NonNullable<GetTenantByDomainResult>
		| NonNullable<GetTenantByIdResult>;
} | null>(null);

export function useTenantContext() {
	const context = React.useContext(TenantContext);

	if (!context) {
		throw new Error("useTenantContext must be used within a TenantProvider");
	}

	return context;
}

export function useActiveTenant():
	| NonNullable<GetTenantByDomainResult>
	| NonNullable<GetTenantByIdResult> {
	const { tenant } = useTenantContext();

	return tenant;
}

export default function TenantProvider({
	children,
	tenant,
}: {
	children: React.ReactNode;
	tenant:
		| NonNullable<GetTenantByDomainResult>
		| NonNullable<GetTenantByIdResult>;
}) {
	const value = React.useMemo(
		() => ({
			tenant,
		}),
		[tenant],
	);

	return (
		<TenantContext.Provider value={value}>{children}</TenantContext.Provider>
	);
}
